import { type ComponentProps } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn, defaultSizesForIcons } from "@genuin/ui/lib/utils";

// Define the playVariant function using cva to handle different styles based on props
const playVariant = cva("", {
  variants: {
    theme: {
      dark: "gencl:fill-white", // Light variant style
      light: "gencl:fill-black", // Dark variant style
    },
    size: defaultSizesForIcons(),
  },
  defaultVariants: {
    theme: "light", // Default to dark theme
    size: "md", // Default size
  },
});

// Define the Props type for the CollapseIcon component
type CollapseIconPropsType = ComponentProps<"svg"> &
  VariantProps<typeof playVariant>;

export function CollapseIcon({
  theme,
  size,
  className,
  ...restProps
}: CollapseIconPropsType) {
  return (
    <svg
      className={cn(playVariant({ theme, size }), className)}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...restProps}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.63819 3.36181C9.40653 3.13015 9.09233 3 8.76471 3C8.43709 3 8.12288 3.13015 7.89122 3.36181C7.65956 3.59347 7.52941 3.90767 7.52941 4.23529L7.52941 7.20988C7.52941 7.29463 7.49575 7.3759 7.43582 7.43582C7.3759 7.49575 7.29463 7.52941 7.20988 7.52941L4.23529 7.52941C3.90767 7.52941 3.59347 7.65956 3.36181 7.89122C3.13015 8.12288 3 8.43709 3 8.76471C3 9.09233 3.13015 9.40653 3.36181 9.63819C3.59347 9.86985 3.90767 10 4.23529 10H7.20988C7.94907 9.9974 8.65723 9.7026 9.17992 9.17992C9.7026 8.65723 9.9974 7.94907 10 7.20988V4.23529C10 3.90767 9.86985 3.59347 9.63819 3.36181ZM16.1088 3.36181C15.8771 3.13015 15.5629 3 15.2353 3C14.9077 3 14.5935 3.13015 14.3618 3.36181C14.1301 3.59347 14 3.90767 14 4.23529V7.20988C14.0026 7.94907 14.2974 8.65723 14.8201 9.17992C15.3428 9.7026 16.0509 9.9974 16.7901 10L19.7647 10C20.0923 10 20.4065 9.86985 20.6382 9.63819C20.8699 9.40653 21 9.09233 21 8.76471C21 8.43709 20.8699 8.12288 20.6382 7.89122C20.4065 7.65956 20.0923 7.52941 19.7647 7.52941L16.7901 7.52941C16.7054 7.52941 16.6241 7.49575 16.5642 7.43582C16.5043 7.3759 16.4706 7.29463 16.4706 7.20988L16.4706 4.23529C16.4706 3.90767 16.3404 3.59347 16.1088 3.36181ZM16.7901 14H19.7647C20.0923 14 20.4065 14.1301 20.6382 14.3618C20.8699 14.5935 21 14.9077 21 15.2353C21 15.5629 20.8699 15.8771 20.6382 16.1088C20.4065 16.3404 20.0923 16.4706 19.7647 16.4706H16.7901C16.7054 16.4706 16.6241 16.5043 16.5642 16.5642C16.5043 16.6241 16.4706 16.7054 16.4706 16.7901V19.7647C16.4706 20.0923 16.3404 20.4065 16.1088 20.6382C15.8771 20.8699 15.5629 21 15.2353 21C14.9077 21 14.5935 20.8699 14.3618 20.6382C14.1301 20.4065 14 20.0923 14 19.7647L14 16.7901C14.0026 16.0509 14.2974 15.3428 14.8201 14.8201C15.3428 14.2974 16.0509 14.0026 16.7901 14ZM7.20988 14H4.23529C3.90767 14 3.59347 14.1301 3.36181 14.3618C3.13015 14.5935 3 14.9077 3 15.2353C3 15.5629 3.13015 15.8771 3.36181 16.1088C3.59347 16.3404 3.90767 16.4706 4.23529 16.4706L7.20988 16.4706C7.29463 16.4706 7.3759 16.5043 7.43582 16.5642C7.49575 16.6241 7.52941 16.7054 7.52941 16.7901L7.52941 19.7647C7.52941 20.0923 7.65956 20.4065 7.89122 20.6382C8.12288 20.8699 8.43709 21 8.76471 21C9.09233 21 9.40653 20.8699 9.63819 20.6382C9.86985 20.4065 10 20.0923 10 19.7647L10 16.7901C9.9974 16.0509 9.7026 15.3428 9.17992 14.8201C8.65723 14.2974 7.94907 14.0026 7.20988 14Z"
      />
    </svg>
  );
}
